function getOsanoScriptUrl(
  osanoCustomerId: string,
  osanoConfigId: string,
): string {
  return `https://cmp.osano.com/${osanoCustomerId}/${osanoConfigId}/osano.js`;
}

export { getOsanoScriptUrl };
